import { Component, inject, OnInit } from '@angular/core';
import { PrimeNG } from 'primeng/config'
import { ThemeService } from '@core/themes/theme.service';
import { RefreshSchedulerService } from '@core/services/refresh-scheduler.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  private readonly themeService = inject(ThemeService);
  private readonly refreshScheduler = inject(RefreshSchedulerService);
  private readonly config = inject(PrimeNG)
  private readonly translateService = inject(TranslateService);

  ngOnInit(): void {
    // Initialize theme based on hostname
    this.themeService.loadTheme();
    // Schedule daily refresh (to prevent bugs related to ticket reservations for past events/dates)
    this.refreshScheduler.scheduleDailyRefresh();
  }

  translate(lang: string) {
    this.translateService.use(lang);
    this.translateService.get('primeng').subscribe(res => {
      this.config.setTranslation(res);
    })
  }
}
